var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function FormTooltip() {
    this.init = function() {
        $(document).on('touchstart', function(e) {
            var $target = $(e.target);

            if ( $target.is( '.gfield_description--tooltip' ) || $target.closest( '.gfield_description--tooltip' ).length > 0 ) {
                e.preventDefault();
                $target.toggleClass( "js-tooltip-active" );
            } else {
                $(".js-tooltip-active").removeClass( "js-tooltip-active" );
            }
        });

    };

    this.init();
}

module.exports = FormTooltip;
